
          export default {
            mounted() { this.key = this.el.dataset.scrollKey },
            updated() {
              if (this.el.dataset.scrollKey !== this.key) {
                this.key = this.el.dataset.scrollKey
                this.el.scrollTop = 0
              }
            }
          }
        